export const toolReducer = (state, action) => {
  return {
    ...state,
    ...action,
  };
};
